import { useAuthStore } from "@/features/auth/stores/authStore";
import { isAuthed } from "@/features/auth/models/authState";
import * as Session from "@/features/auth/services/session";

type Credentials = {
  userId: string | null;
  token: string | null;
};

const getUserCredentials = (): Credentials => {
  const state = useAuthStore.getState();

  if (isAuthed(state)) {
    return {
      userId: state.session.userId,
      token: state.session.token,
    };
  }

  return {
    userId: null,
    token: null,
  };
};

const revokeSession = async () => {
  return await Session.handleUnauthorized();
};

export { getUserCredentials, revokeSession };
